import * as React from 'react';
export var Minus = function () {
    return React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-hidden": "true" },
        React.createElement("path", { d: "M4 11.6A1.6 1.6 0 0 1 5.6 10h12.8a1.6 1.6 0 1 1 0 3.2H5.6A1.6 1.6 0 0 1 4 11.6", fill: "currentColor" }));
};
